
export const DISCOVERY_API_ENDPOINTS = {
  ADD_DISCOVERY: "/cms/add-discovery",
  GET_DISCOVERY_DETAILS: "/cms/get-discovery-details",
  UPDATE_DISCOVERY: "/cms/update-discovery",
  GET_APPLICATİON_LIST: "/cms/get-application-list",
}

export interface DiscoveryDetail {
  title: string;
  description: string;
  culture: string;
}

export interface DiscoveryData {
  isVisible: boolean;
  displayOrder: number | undefined;
  discoveryDetails: DiscoveryDetail[];
  discoveryId?: string;
  targetUrl: string;
  tinyUrlName: string;
  applicationId: string | undefined;
}

export const defaultDiscoveryData: DiscoveryData = {
  isVisible: false,
  displayOrder: undefined,
  targetUrl: "",
  tinyUrlName: "",
  discoveryDetails: [
    {
      title: "",
      description: "",
      culture: "tr-TR"
    },
    {
      title: "",
      description: "",
      culture: "en-US"
    }
  ],
  applicationId: undefined,
};

export interface ApplicationData {
  value: string;
  label: string;
}